<div class="lane-toggler">
  <div class="button-list">
    <button
      *ngFor="let lane of workItemLanes"
      class="toggle-btn icon-button"
      [ngClass]="{ 'toggle-btn-active': isVisible(lane) }"
      [attr.data-automation-id]="lane.name"
      (click)="onButtonClick(lane)">
        <svg-icon *ngIf="lane.icon" [icon]="lane.icon"></svg-icon>

        <span class="btn-label" *ngIf="!lane.icon">{{ lane.name[0] }}</span>

        <svg-icon class="btn-popup" *ngIf="isPopupIntegration(lane)" [icon]="'panel-popup'"></svg-icon>

        <ng2-tooltip direction="bottom" text="{{ lane.tooltip | translate }}"></ng2-tooltip>
    </button>
    <div class="save-container" *ngIf="!isWorkItemEnded">
      <button (click)="saveNewDefaultSettings()" data-automation-id="save-new-default-lane-view-btn" class="toggle-btn icon-button save-button" [disabled]="!isSettingDifferent">
        <svg-icon icon="save"></svg-icon>
        <ng2-tooltip direction="bottom" text="{{ 'laneButtons.saveDefaultSwimlanes' | translate: { itemType: itemType } }}"></ng2-tooltip>
      </button>
    </div>
  </div>
</div>
